/* eslint-disable no-console */
import { useState, useEffect, useCallback } from 'react';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { unwrapAttendanceConfirmationList } from '../utils/tenderEvaluationHelpers';

const useTenderEvaluationAttendance = (
  procId,
  { enabled = true, isActive = true } = {}
) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAttendance = useCallback(async () => {
    const token = getAuthToken();
    if (!token || !procId || !enabled) return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `${api.API_URL}/procurement/get-tender-evaluation-attendance?ProcurementId=${encodeURIComponent(procId)}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to load attendance confirmation data');
      }

      const result = await response.json();
      setItems(unwrapAttendanceConfirmationList(result));
    } catch (err) {
      console.error('Error fetching attendance confirmation:', err);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, [procId, enabled]);

  useEffect(() => {
    if (!enabled || !procId || !isActive) return;
    fetchAttendance();
  }, [enabled, procId, isActive, fetchAttendance]);

  return { items, isLoading, refresh: fetchAttendance };
};

export default useTenderEvaluationAttendance;
